import request from "@/utils/request";

export function getInstagramAccounts(page = 1) {
    return request({
        url: "/instagram/list",
        method: "get",
        params: {
            page
        }
    });
}

export function getTiktokAccounts(page = 1) {
    return request({
        url: `/tiktok/list`,
        method: "get",
        params: {
            page
        }
    });
}

export function deleteTiktokAccount(id) {
    return request({
        url: `tiktok/${id}`,
        method: "delete"
    });
}

export function deleteInstagramAccount(id) {
    return request({
        url: `instagram/${id}`,
        method: "delete"
    });
}

export function getInstagramStatistic() {
    return request({
        url: `instagram/getStatistic`,
        method: "get"
    });
}

export function getTiktokStatistic() {
    return request({
        url: `tiktok/getStatistic`,
        method: "get"
    });
}

export function storeInstagramAccount(account) {
    return request({
        url: "/instagram/store",
        method: "post",
        data: account
    });
}

export function storeTiktokAccount(account) {
    return request({
        url: "/tiktok/store",
        method: "post",
        data: account
    });
}

export function getInstagramAccountByQuery(query) {
    return request({
        url: `/instagram/get-instagram-account/${query}`,
        method: "get"
    });
}

export function getTiktokAccountByQuery(query) {
    return request({
        url: `/tiktok/get-tiktok-account/${query}`,
        method: "get"
    });
}

export function getInstagramAccount(id) {
    return request({
        url: `/instagram/${id}`,
        method: "get"
    });
}

export function getTiktokAccount(id) {
    return request({
        url: `/tiktok/${id}`,
        method: "get"
    });
}

export function getInstagramPosts(variables) {
    return request({
        url: '/instagram/get-instagram-posts/' + variables,
        method: "get"
    });
}

export function getTiktokPosts(variables) {
    return request({
        url: '/tiktok/get-tiktok-posts/' + variables,
        method: "get"
    });
}


export function updateAccountInstagram(account) {
    return request({
        url: '/instagram/update',
        method: 'put',
        data: account,
    });
}

export function updateAccountTiktok(account) {
    return request({
        url: '/tiktok/update',
        method: 'put',
        data: account,
    });
}
export function getTiktokLoginUrl() {
    return request({
        url: '/tiktok-user/get-login-url',
        method: 'get',
    });
}

export function getTiktokUser(code) {
    return request({
        url: '/tiktok-user/get-user/' + code,
        method: 'get',
    });
}
